import { Schema } from "@components:SchemaForm";

import schemaJson from "./ai_settings_schema.json";

// Generated by `npm run update-schemas` from the API's `AISettings` model
export const aiSettingsSchema = schemaJson as Schema;
